import script from "./esFinancialGroupDetailSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esFinancialGroupDetailSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esFinancialGroupDetailSettings.vue?vue&type=style&index=0&id=7a564d02&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a564d02"]])

export default __exports__